import { Injectable } from '@angular/core';

import { GlobalDataService } from '@providers/global-data/global-data.service';

@Injectable({
  providedIn: 'root'
})
export class ModelsToolsService {
  constructor(
    private globalDataService: GlobalDataService
  ) {}

  public isStepValid(id: any, mode: ('id' | 'slug') = 'id'): boolean {
    // Select step category
    const categoryRange = this.globalDataService.stepsCategory
      .filter(i => i.name === 'Études' || i.name === 'S.A.V' || i.name === 'Travaux')
      .map(i => i.id);
    const stepsRange = this.globalDataService.steps
      .filter(i => categoryRange.includes(i.id_step_category));
    const found = stepsRange
      .find(i => i[mode] === id);

    return !!found;
  }

  public isDesignStep(id: any, mode: ('id' | 'slug') = 'id'): boolean {
    // Select step category
    const designCategory = this.globalDataService.stepsCategory.find(i => i.name === 'Études');

    const found = this.globalDataService.steps.find(i => i[mode] === id);

    if (found) {
      return designCategory.id === found.id_step_category;
    }

    return false;
  }
}
